import React, { Component } from "react";
import { Card, Row, Col, Button, Form } from "react-bootstrap";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import DataTable from "react-data-table-component";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { connect } from "react-redux";
import { SuperAdminAction, TicketActions } from "../../Actions";
import Loader from "../Loader/Loader";
import CustomContentAlert, {
  tableHeightScrollBars,
  findBySearch,
  utcToSpecificTimeZone,
} from "../helper";
import isEqual from "lodash/isEqual";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropertDetails from "../LandingPage/PropertySelection";
import { saveAs } from "file-saver";
import moment from "moment";
const moment_timezone = require("moment-timezone");

class ByEnfocer extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.state = {
      PropertyId: this.props.PropertyId,
      enforcerList: [],
      loader: false,
      user_type: this.props.user_type,
      suite_id: this.props.suite_id,
      searchValue: "",
      api_response: false,
      show_alert: false,
      api_success_message: "",
      api_error_message: "",
      page: 1,
      Norow: 100,
      selectedColumn: "created_at",
      asc: "false",
      sort_direction: "DESC",
      pageChanged: false,
      findMore: false,
      count: 0,
      timezone: this.props.timezone,
      property: this.props.property,
      isFormValid: true,
      status: "",
      show: false,
      ticketDetails: {},
      state: "",
      selectedPropertyObj: {},
      all_proparties: [],
      childcheckbox: true,
      ticketReportLots: [],
      lot_id: "",
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      currentDate: "",
      month: "",
      year: "",
      activeTab: "1",
      apiResponse: "",
      dateRanges: [
        {
          startDate: new Date(),
          endDate: null,
          key: "selection",
        },
      ],
      exportButtonDisable: true,
      finalTableHeight: 0,
      daysDifference: 30,
      newAdd: false,
    };

    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };

    this.columns = [
      {
        name: "Mon",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.mon ? row.mon : "-"}</div>,
        selector: (row) => row.mon,
      },
      {
        name: "Month",
        width: "130px",
        sortable: true,
        cell: (row) => (
          <div>
            <a>{row.month ? row.month : "-"}</a>
          </div>
        ),
        selector: (row) => row.month,
      },
      {
        name: "Enforcer",
        width: "130px",
        sortable: true,
        cell: (row) => <div>{row.enforcer ? row.enforcer : "-"}</div>,
        selector: (row) => row.enforcer,
      },
      {
        name: "Issued #",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row?.issued}</div>,
        selector: (row) => row.issued,
      },
      {
        name: "Issued $",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.issuedFee ? `$${row.issuedFee}` : "-"}</div>,
        selector: (row) => row.issuedFee,
      },
      {
        name: "Payable #",
        width: "100px",
        sortable: true,
        cell: (row) => (
          <div>{row.actualCitations ? row.actualCitations : "-"}</div>
        ),
        selector: (row) => row.actualCitations,
      },
      {
        name: "Payable $",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.actualFee ? `$${row.actualFee}` : "-"}</div>,
        selector: (row) => row.actualFee,
      },
      {
        name: "Payable # %",
        width: "130px",
        sortable: true,
        cell: (row) => (
          <div>{row.actualPaidPer ? `${row.actualPaidPer}` : "-"}</div>
        ),
        selector: (row) => row?.actualPaidPer,
      },
      {
        name: "Refund #",
        sortable: true,
        width: "100px",
        cell: (row) => <div>{row.refund ? row.refund : "0"}</div>,
        selector: (row) => row.refund,
      },
      {
        name: "Refund $",
        sortable: true,
        width: "100px",
        cell: (row) => <div>{row.refundFee ? `$${row.refundFee}` : "0"}</div>,
        selector: (row) => row.refundFee,
      },
      {
        name: "Refund # %",
        sortable: true,
        width: "120px",
        cell: (row) => <div>{row.refundPer ? row.refundPer : "0"}</div>,
        selector: (row) => row.refundPer,
      },
    ];

    this.addNewColumn = [
      {
        name: "Mon",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.mon ? row.mon : "-"}</div>,
        selector: (row) => row.mon,
      },
      {
        name: "Date",
        width: "170px",
        sortable: true,
        cell: (row) => (
          <div>
            <a>
              {" "}
              {row.date
                ? utcToSpecificTimeZone(this.props.timezone, row.date)
                : "-"}
            </a>
          </div>
        ),
        selector: (row) => row.Date,
      },
      {
        name: "Enforcer",
        width: "130px",
        sortable: true,
        cell: (row) => <div>{row.enforcer ? row.enforcer : "-"}</div>,
        selector: (row) => row.enforcer,
      },
      {
        name: "Issued #",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.issued ? row.issued : "-"}</div>,
        selector: (row) => row.issued,
      },
      {
        name: "Issued $",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.issuedFee ? `$${row.issuedFee}` : "-"}</div>,
        selector: (row) => row.issuedFee,
      },
      {
        name: "Payable #",
        width: "100px",
        sortable: true,
        cell: (row) => (
          <div>{row.actualCitations ? row.actualCitations : "-"}</div>
        ),
        selector: (row) => row.actualCitations,
      },
      {
        name: "Payable $",
        width: "100px",
        sortable: true,
        cell: (row) => <div>{row.actualFee ? `$${row.actualFee}` : "-"}</div>,
        selector: (row) => row.actualFee,
      },
      {
        name: "Payable # %",
        width: "130px",
        sortable: true,
        cell: (row) => (
          <div>{row.actualPaidPer ? `${row.actualPaidPer}` : "-"}</div>
        ),
        selector: (row) => row?.actualPaidPer,
      },
      {
        name: "Refund #",
        sortable: true,
        width: "100px",
        cell: (row) => <div>{row.refund ? row.refund : "0"}</div>,
        selector: (row) => row.refund,
      },
      {
        name: "Refund $",
        sortable: true,
        width: "100px",
        cell: (row) => <div>{row.refundFee ? `$${row.refundFee}` : "0"}</div>,
        selector: (row) => row.refundFee,
      },
      {
        name: "Refund # %",
        sortable: true,
        width: "120px",
        cell: (row) => <div>{row.refundPer ? row.refundPer : "0"}</div>,
        selector: (row) => row.refundPer,
      },
    ];
  }

  changeProperty(event) {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.setState(
      {
        selectedProperty: event.value,
        selectedPropertyObj: event,
        startDate: new Date(datebeforeThirtyDays),
        endDate: new Date(),
        month: null,
        year: null,
        currentDate: null,
      },
      () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.selectedProperty
        );
        this.props.selected_Property(selectedPropertyObj);
        this.props.get_all_lots(event.value);
        const current_lot = this.props.lots;
        this.setState({
          ticketReportLots: current_lot,
        });
        this.setState({
          isFormValid: true,
          pageDropdownDisabled: false,
        });
      }
    );
  }

  handleCheckBox = () => {
    this.setState({ childcheckbox: !this.state.childcheckbox });
  };

  componentDidMount = async () => {
    await this.getTickets();
    await this.props.get_all_properties();
    const { PropertyId } = this.state;
    await this.props.get_all_lots(PropertyId);
    const current_lot = this.props.lots;
    this.setState(
      {
        api_response: this.props?.api_response,
        all_properties: this.props?.getAllProperties,
        ticketReportLots: current_lot,
      },
      async () => {
        const selectedPropertyObj = this.state.all_properties.find(
          (item) => item.id === PropertyId
        );
        if (selectedPropertyObj) {
          this.setState({
            selectedPropertyObj: {
              label: selectedPropertyObj.site_name,
              value: selectedPropertyObj.id,
            },
            selectedProperty: PropertyId,
            selectedDomainName: selectedPropertyObj.site_name,
          });
        }
      }
    );

    const height = tableHeightScrollBars();
    this.setState({
      finalTableHeight: height,
    });
  };

  getTickets = async () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        state,
        selectedColumn,
        sort_direction,
        PropertyId,
        childcheckbox,
        timezone,
        startDate,
        endDate,
      } = this.state;
      const pageobj = {
        page,
        Norow,
        state,
        selectedColumn,
        sort_direction,
        PropertyId,
        timezone,
        childcheckbox,
      };
      if (startDate) {
        pageobj.startDate = startDate;
      }
      if (endDate) {
        pageobj.endDate = endDate;
      }
      await this.props.getReportList(pageobj);
      const selectedPropertyName = this.state.property?.property_name;
      const selectedDomainName = this.state.property?.domain;
      await this.props.setDomainHeader(
        selectedPropertyName,
        selectedDomainName
      );
      this.setState({
        enforcerList:
          this.props.enforcerList &&
          this.props.enforcerList.rows &&
          this.props.enforcerList.rows.length
            ? JSON.parse(JSON.stringify(this.props.enforcerList.rows))
            : [],
        api_response: this.props.api_response,
        count: this.props.enforcerList.count,
      });
      this.setState({ loader: false });
    });
  };

  componentDidUpdate = async (prevProps) => {
    if (!isEqual(prevProps.enforcerList, this.props.enforcerList)) {
      this.setState({
        enforcerList: JSON.parse(JSON.stringify(this.props.enforcerList.rows)),
        // enforcerList: JSON.parse(JSON.stringify(this.props.enforcerList.rows)),
        pageChanged: true,
        count: this.props.enforcerList.count,
      });
    }
    if (!isEqual(prevProps.lots, this.props.lots)) {
      this.setState({
        ticketReportLots: this.props.lots,
      });
    }
  };

  dataTableHandle = (enforcerList) => {
    return (
      <DataTable
        data={
          this.state.searchValue.length
            ? this.state.searchedtransactionsList
            : enforcerList
        }
        columns={
          this.state.month || this.state.currentDate
            ? this.addNewColumn
            : this.columns
        }
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={this.state.Norow}
        paginationTotalRows={this.state.count}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  handleCurrentDate = (date) => {
    this.setState({
      currentDate: date,
      month: null,
      year: null,
      startDate: null,
      endDate: null,
    });
  };

  handleSearch = () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        selectedColumn,
        sort_direction,
        lot_id,
        childcheckbox,
        month,
        year,
        currentDate,
        startDate,
        endDate,
        selectedPropertyObj,
        PropertyId,

        timezone,
      } = this.state;
      const pageobj = {
        page,
        Norow,
        selectedColumn,
        sort_direction,
        childcheckbox,
        PropertyId,
        timezone,
      };
      if (Object.keys(selectedPropertyObj).length) {
        pageobj.PropertyId = selectedPropertyObj.value;
      } else {
        pageobj.PropertyId = PropertyId;
      }
      if (lot_id) {
        pageobj.lot_id = lot_id;
      }
      if (currentDate) {
        pageobj.currentDate = currentDate;
        this.setState({
          newAdd: true,
        });
      }
      if (month) {
        pageobj.month = month;
        this.setState({
          newAdd: false,
        });
      }
      if (year) {
        pageobj.year = moment_timezone(year).format("YYYY");
      }
      if (startDate && endDate) {
        pageobj.startDate = startDate;
        pageobj.endDate = endDate;
      }
      await this.props.getReportList(pageobj);

      this.setState({
        enforcerList: JSON.parse(JSON.stringify(this.props.enforcerList.rows)),
        api_response: this.props.api_response,
        count: this.props.enforcerList.count,
        exportButtonDisable: false,
      });
      this.setState({ loader: false });
      document.body.classList.remove("foc-open");
    });
  };

  handleSearchChange = async ({ target }) => {
    this.setState({ searchValue: target.value }, async () => {
      const columnList = [
        "mon",
        "month",
        "date",
        "enforcer",
        "issued",
        "issuedFee",
        "actualCitations",
        "actualFee",
        "actualPaidPer",
      ];
      if (this.state.searchValue.length) {
        if (!this.state.findMore) {
          this.setState(
            {
              searchedtransactionsList: findBySearch(
                this.state.searchValue,
                this.state.enforcerList,
                this.state.enforcerList,
                columnList,
                this.props.timezone
              ),
            },
            () => {
              this.setState({
                count: this.state.searchedtransactionsList.length,
              });
            }
          );
        }
      } else {
        this.setState({
          count: this.props.enforcerList.count,
          searchedtransactionsList: [],
          enforcerList: this.props.enforcerList.rows,
        });
      }
    });
  };

  resetAll = async () => {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(
      today.getDate() - this.state.daysDifference
    );
    this.setState({
      month: null,
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      year: null,
      currentDate: null,
      selectedPropertyObj: {},
      lot_id: "",
      childcheckbox: true,
      exportButtonDisable: true,
      newAdd: false,
    });
    const {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      PropertyId,
      startDate,
      endDate,
      selectedDomainName,
      timezone,
    } = this.state;
    const pageobj = {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      PropertyId,
      timezone,
    };
    if (startDate) {
      pageobj.startDate = new Date(datebeforeThirtyDays);
    }
    if (endDate) {
      pageobj.endDate = new Date();
    }
    await this.props.getReportList(pageobj);
    this.setState({
      pageChanged: true,
      page: 1,
      enforcerList: this.props.enforcerList.rows,
      count: this.props.enforcerList.count,
      selectedPropertyObj: {
        label: selectedDomainName,
        value: PropertyId,
      },
    });
    setTimeout(() => {
      this.setState({ findMore: false });
    }, 2000);
    this.setState({ loader: false });
    document.body.classList.remove("foc-open");
  };

  hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  handleExport = async () => {
    const {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      lot_id,
      childcheckbox,
      month,
      year,
      currentDate,
      startDate,
      endDate,

      selectedPropertyObj,
      PropertyId,
      detailedDate,
      selectedDomainName,
      timezone,
    } = this.state;
    const pageobj = {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      childcheckbox,
      PropertyId,
      timezone,
      exportData: true,
    };
    if (Object.keys(selectedPropertyObj).length) {
      pageobj.PropertyId = selectedPropertyObj.value;
    } else {
      pageobj.PropertyId = PropertyId;
    }
    if (lot_id) {
      pageobj.lot_id = lot_id;
    }
    if (currentDate) {
      pageobj.currentDate = currentDate;
    }
    if (detailedDate) {
      pageobj.detailedDate = detailedDate;
    }
    if (month) {
      pageobj.month = month;
    }
    if (year) {
      pageobj.year = moment_timezone(year).format("YYYY");
    }
    if (startDate && endDate) {
      pageobj.startDate = startDate;
      pageobj.endDate = endDate;
    }
    const bufferData = await this.props.getReportList(pageobj);
    const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
    const exportDataName = `BY_ENFOCER-${currentTimeDate}-${selectedDomainName}.xls`;
    if (bufferData) {
      saveAs(
        new Blob([bufferData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        exportDataName
      );
    }
  };

  handleMonth = (date) => {
    this.setState({
      month: date,
      startDate: null,
      endDate: null,
      currentDate: null,
      loader: false,
    });
  };

  render() {
    const {
      enforcerList,
      loader,
      childcheckbox,
      // ticketReportLots,
      // lot_id,
      //   startDate,
      //   endDate,
      currentDate,
      searchValue,
      month,
      //  year,
    } = this.state;

    return (
      <div>
        <Card className="mb-0">
          <Card.Body className="pos-rel-overflow-hide">
            <>
              <div className="sidebarFilter">
                <Card className="contact-container mb-0">
                  <Card.Header
                    style={{ backgroundColor: this.props.main_body }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <Card.Title as="h4">By Enforcer</Card.Title>
                      <a
                        onClick={this.hideSlider}
                        href="javascript:void(0);"
                        className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </a>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md="12">
                        <div className="mb-2">
                          <label className="fancy-checkbox">
                            <input
                              type="checkbox"
                              name={"childcheckbox"}
                              checked={childcheckbox}
                              onChange={this.handleCheckBox}
                              className="custom-control-input"
                              id="childcheckbox1"
                            ></input>
                            <span>
                              <i></i>Include Children Sites
                            </span>
                          </label>
                        </div>
                      </Col>
                      <Col md="12">
                        <PropertDetails
                          selectedPropertyObj={this.state.selectedPropertyObj}
                          changeProperty={this.changeProperty.bind(this)}
                        />
                      </Col>
                      {/* <Col md="12">
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Form.Label>LOTS:</Form.Label>
                          <Form.Control
                            as="select"
                            name="lot_id"
                            value={lot_id}
                            onChange={this.handleChangeLot}
                            disabled={ticketReportLots.length < 1}
                            placeholder="Select Lot"
                          >
                            {ticketReportLots && ticketReportLots.length ? (
                              <>
                                <option value="">Any</option>
                                {ticketReportLots.map((item, index) => (
                                  <option key={index} value={item.id}>
                                    {item.alias}
                                  </option>
                                ))}
                              </>
                            ) : null}
                          </Form.Control>
                        </Form.Group>
                      </Col> */}
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Date"
                            selected={currentDate}
                            value={currentDate}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleCurrentDate}
                            dateFormat="MM/dd/yyyy"
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">MONTH:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Month"
                            selected={month}
                            value={month}
                            disabled={loader}
                            onChange={this.handleMonth}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">START DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Start Date"
                            selected={startDate}
                            defaultHour={24}
                            value={startDate}
                            disabled={loader}
                            selectsStart
                            timeInputLabel="Time:"
                            onChange={this.handleChangeStartingDates}
                            dateFormat="MM/dd/yyyy"
                            startDate={startDate}
                            endDate={endDate}
                            maxDate={
                              this.state.endDate
                                ? this.state.endDate
                                : new Date()
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col md="12">
                        <Form.Group>
                          <label className="mb-0 mr-2">END DATE:</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select End Date"
                            selected={endDate}
                            disabled={loader}
                            value={endDate}
                            selectsEnd
                            timeInputLabel="Time:"
                            onChange={this.handleChangeEndDates}
                            // dateFormat="MM/dd/yyyy hh:mm:ss aa"
                            dateFormat="MM/dd/yyyy"
                            // showTimeInput
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            maxDate={endDate}
                          />
                        </Form.Group>
                      </Col> */}
                    </Row>
                  </Card.Body>
                  <Card.Footer className="text-right justify-content-between d-flex">
                    <Button
                      variant="info"
                      className="h-40 custom-btn-secondary btn-sm"
                      onClick={this.resetAll}
                      disabled={loader}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="info"
                      className="h-40 btn-fill btn-sm ml-2"
                      onClick={this.handleSearch}
                      disabled={loader}
                    >
                      Search
                    </Button>
                  </Card.Footer>
                </Card>
              </div>
              <header>
                <div className="active-permit-header sm-flex-column sm-align-items-start">
                  <h5 className="mb-2 mb-md-0"></h5>
                  <div className="filter-button d-flex flex-wrap">
                    <div className="d-flex align-items-center search-mb-0">
                      <DatatableHeader
                        className="mt-0 mb-0"
                        searchValue={searchValue}
                        HandleChange={this.handleSearchChange}
                        // findMorePressed={this.findMorePressed}
                      />
                    </div>
                    <div className="ml-2">
                      <Button
                        variant="info"
                        className="btn-fill btn-sm"
                        onClick={this.handleExport}
                        disabled={enforcerList.length > 0 ? 0 : 1}
                        size="medium"
                      >
                        Export
                      </Button>
                    </div>
                  </div>
                </div>
              </header>
            </>
            {loader ? (
              <Loader />
            ) : (
              <>
                {this.state.show_alert && (
                  <CustomContentAlert
                    delay={2000}
                    message={this.state.api_success_message}
                    className="toast-success"
                  />
                )}
                {enforcerList && (
                  <>
                    <div className="citation-list-table">
                      {this.dataTableHandle(enforcerList)}
                    </div>
                  </>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
  SuperAdminDetails,
  CurrentPermitDetails,
  TicketDetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const {
    property_id: PropertyId,
    user_type,
    suite_id,
    timezone,
    property,
  } = UserProfileDetails;

  const { backgroundColor } = Logindetails;
  const { residentList } = CurrentPermitDetails;
  const { getAllProperties, lots } = SuperAdminDetails;
  const { MainBackground: main_body } = backgroundColor;
  const { enforcerList } = TicketDetails;
  return {
    api_response,
    api_error_message,
    api_success_message,
    PropertyId,
    user_type,
    suite_id,
    timezone,
    property,
    enforcerList,
    main_body,
    getAllProperties,
    residentList,
    lots,
  };
};

const mapStateToDispatch = {
  setDomainHeader: SuperAdminAction.setDomainHeader,
  get_all_properties: SuperAdminAction.get_all_properties,
  selected_Property: SuperAdminAction.selected_Property,
  get_all_lots: SuperAdminAction.get_all_lots,
  getReportList: TicketActions.getByEnfocerList,
};

export default connect(mapStateToProps, mapStateToDispatch)(ByEnfocer);
